import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Text } from '@travel-frontend/core';
export const CountryCode = /*#__PURE__*/_styled(Text, process.env.NODE_ENV === "production" ? {
  target: "e1dvrvb50"
} : {
  target: "e1dvrvb50",
  label: "CountryCode"
})(process.env.NODE_ENV === "production" ? {
  name: "158icaa",
  styles: "margin-left:4px"
} : {
  name: "158icaa",
  styles: "margin-left:4px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvdW50cnlDb2RlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV3QyIsImZpbGUiOiJDb3VudHJ5Q29kZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRleHQgfSBmcm9tICdAdHJhdmVsLWZyb250ZW5kL2NvcmUnO1xuZXhwb3J0IGNvbnN0IENvdW50cnlDb2RlID0gc3R5bGVkKFRleHQpIGBcbiAgbWFyZ2luLWxlZnQ6IDRweDtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db3VudHJ5Q29kZS5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});